import React, { useState, useEffect } from "react";
import { Dropdown, Row, Tab, Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import {
  downloadAllPlayers,
  getAllReportPlayer,
  getDuesPlayersInvoice,
  getPlayerSubscription,
} from "../../../../services/academicService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from "react-select";
import DatePicker from "react-datepicker";
import DuesPaymentModal from "../../../components/reports/DuesPaymentModal";
import {
  getPublicAgeCategory,
  getPublicPaymentStatus,
} from "../../../../services/publicService";
import { getTenantReport } from "../../../../services/ReportService";

const theadData = [
  { heading: "Name", sortingVale: "name" },
  { heading: "Email", sortingVale: "email" },
  { heading: "Mobile", sortingVale: "phone" },
  { heading: "Contact Name", sortingVale: "name" },
  { heading: "Owner Name", sortingVale: "ownerName" },
  { heading: "Owner Mobile", sortingVale: "ownerMobile" },
  { heading: "Subscription", sortingVale: "subscription" },
  { heading: "Grace Days", sortingVale: "graceDays" },
  { heading: "Grace Period", sortingVale: "gracePeriod" },
  { heading: "Start Date", sortingVale: "startDate" },
  { heading: "Expire Date", sortingVale: "expireDate" },
  { heading: "Status", sortingVale: "status" },
];

const svg1 = (
  <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect x="0" y="0" width="24" height="24"></rect>
      <circle fill="#000000" cx="5" cy="12" r="2"></circle>
      <circle fill="#000000" cx="12" cy="12" r="2"></circle>
      <circle fill="#000000" cx="19" cy="12" r="2"></circle>
    </g>
  </svg>
);

const AcademicesReport = () => {
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);
  // pagination & search
  const [page, setPage] = useState(0); // 0-based
  const [size, setSize] = useState(10); // page size
  const [search, setSearch] = useState(""); // search text
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentStart, setCurrentStart] = useState(0);
  const [paymentModal, setPaymentModal] = useState(false);
  //filter
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState([]);
  const [ageCategory, setAgeCategory] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [packageData, setPackageData] = useState(null);
  const [open, setOpen] = useState(true);
  //palyer dropdown
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [tenantOptions, setTenantOptions] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0); // 0-based
  const [tenantSearch, setTenantSearch] = useState("");
  const pageSize = 20;
  const [iconData, setIconDate] = useState({ complete: false, ind: Number });
  const [selectedStatus, setSelectedStatus] = useState(null);

  const formatDate = (date) => {
    if (!date) return null;
    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  // ---- API CALL WITH page, size, search ----
  async function fetchUserData({ page, size, search }) {
    setLoading(true);
    try {
      const res = await getTenantReport(
        page,
        size,
        search,
        formatDate(startDate),
        formatDate(endDate),
        selectedStatus
      );
      setUserData(res?.content || []);
      setTotalElements(res?.totalElements || 0);
      setTotalPages(res?.totalPages || 0);
      setCurrentStart(res?.number || 0);
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  }

  // initial & whenever page/size/search changes
  useEffect(() => {
    fetchUserData({
      page,
      size,
      search,
      startDate,
      endDate,
      selectedStatus
    });
  }, [page, size, search, startDate, endDate, selectedStatus]);

  // ---- client sorting (optional; if you want server-side sort, pass sort to API instead) ----
  function SotingData(name) {
    const sortedPeople = [...userData];
    switch (name) {
      case "name":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name),
        );
        break;

      case "email":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? a.name.localeCompare(b.name)
            : b.name.localeCompare(a.name),
        );
        break;

      case "landLine":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a.landLine || "").localeCompare(b.landLine || "")
            : (b.landLine || "").localeCompare(a.landLine || ""),
        );
        break;

      case "phone":
        sortedPeople.sort((a, b) =>
          iconData.complete
            ? (a.phone || "").localeCompare(b.phone || "")
            : (b.phone || "").localeCompare(a.phone || ""),
        );
        break;

      default:
        break;
    }
    setUserData(sortedPeople);
  }

  // ---- Search handler ----
  function handleSearchChange(e) {
    const value = e.target.value;
    setSearch(value);
    setPage(0); // reset to first page on search
  }

  const downloadExcel = async () => {
    try {
      const res = await getTenantReport(
        0,
        1000,
        search,
        formatDate(startDate),
        formatDate(endDate),
        selectedStatus
      );

      const formattedData = res?.content?.map((data, index) => ({
        "S.No": index + 1,
        Name: data?.name || "",
        Email: data?.email || "",
        Mobile: data?.phone || "",
        "Contact Name": data?.contactName || "",
        "Owner Name": data?.owner?.name || "",
        "Owner Mobile": data?.owner?.phone || "",
        Subscription: data?.tenantSubcription?.tenantSubscriptionEnum || "",
        "Grace Days": data?.tenantSubcription?.graceDays ?? "",
        "Grace Period": data?.tenantSubcription?.gracePeriod
          ? new Date(
              data?.tenantSubcription?.gracePeriod + "Z"
            ).toLocaleString()
          : "-",
        "Start Date": data?.tenantSubcription?.startDate
          ? new Date(data.tenantSubcription.startDate).toLocaleString()
          : "-",
        "Expire Date": data?.tenantSubcription?.expireDate
          ? new Date(data.tenantSubcription.expireDate).toLocaleString()
          : "-",
        Status: data?.status || "",
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Academies Report");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(file, "academies-report.xlsx");
    } catch (error) {
      console.error("Excel download failed:", error);
    }
  };



  return (
    <>
      <PageTitle activeMenu={"Academices Reports"} motherMenu={"Reports"} />
      <div className="filter cm-content-box box-primary">
        <div className={`content-title`} onClick={() => setOpen(!open)}>
          <div className="cpa">
            <i className="fas fa-filter me-2"></i>Filter
          </div>
          <div className="tools">
            <Link
              to={"#"}
              className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
            >
              <i className="fas fa-angle-up"></i>
            </Link>
          </div>
        </div>
        <Collapse in={open}>
          <div className="cm-content-body form excerpt">
            <div className="card-body">
              <div className="row">

                <div className="col-md-3">
                  <label className="form-label">Start Date</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => {
                      setStartDate(date);
                      setEndDate(null); // reset end date
                    }}
                    maxDate={new Date()}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="Select start date"
                  />
                </div>

                <div className="col-md-3">
                  <label className="form-label">End Date</label>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    minDate={startDate}
                    maxDate={
                      startDate
                        ? new Date(
                          new Date(startDate).setDate(
                            startDate.getDate() + 90,
                          ),
                        )
                        : new Date()
                    }
                    disabled={!startDate}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="Select end date"
                  />
                </div>

                <div className="col-xl-3">
                  <label className="form-label">Status</label>
                  <Select
                    isSearchable={false}
                    options={[
                      { value: "", label: "Select Status" },
                      { value: "ACTIVE", label: "Active" },
                      { value: "INACTIVE", label: "Inactive" },
                    ]}
                    className="custom-react-select"
                    onChange={(e) => setSelectedStatus(e.value)}
                    placeholder="Select Status"
                  />
                </div>

                <div className="col-xl-3 d-flex align-items-end mt-3">
                  <button
                    type="button"
                    className="btn btn-success"
                    style={{ height: "2.8rem" }}
                    onClick={downloadExcel}
                  >
                    <i className="fas fa-file-excel me-2"></i> Download
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>
      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              {/* LIST VIEW */}
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dataTables_wrapper no-footer">
                      <div className="justify-content-between d-sm-flex mb-3">
                        {/* PAGE SIZE DROPDOWN */}
                        <div className="dataTables_length">
                          <label className="d-flex align-items-center">
                            Show
                            <Dropdown className="search-drop ms-2 me-2">
                              <Dropdown.Toggle
                                as="div"
                                className="search-drop-btn"
                              >
                                {size}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {[10, 20, 30].map((val) => (
                                  <Dropdown.Item
                                    key={val}
                                    onClick={() => {
                                      setSize(val);
                                      setPage(0);
                                    }}
                                  >
                                    {val}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                            entries
                          </label>
                        </div>

                        {/* SEARCH */}
                        <div className="dataTables_filter">
                          <label>
                            Search :{" "}
                            <input
                              type="search"
                              className=""
                              placeholder=""
                              value={search}
                              onChange={handleSearchChange}
                            />
                          </label>
                        </div>
                      </div>

                      {/* TABLE WITH HORIZONTAL SCROLL */}
                      <div className="table-responsive">
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    if (item.sortingVale === "action") return;
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                  style={
                                    item.sortingVale !== "action"
                                      ? { cursor: "pointer" }
                                      : {}
                                  }
                                >
                                  {item.heading}
                                  {item.sortingVale !== "action" && (
                                    <span>
                                      {ind !== iconData.ind && (
                                        <i
                                          className="fa fa-sort ms-2 fs-12"
                                          style={{ opacity: "0.3" }}
                                        />
                                      )}
                                      {ind === iconData.ind &&
                                        (iconData.complete ? (
                                          <i
                                            className="fa fa-arrow-down ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ) : (
                                          <i
                                            className="fa fa-arrow-up ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ))}
                                    </span>
                                  )}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {userData.map((data, ind) => (
                              <tr key={ind}>
                                <td>{data?.name}</td>
                                <td>{data?.email}</td>
                                <td>{data?.phone}</td>
                                <td>{data?.contactName}</td>
                                <td>{data?.owner?.name}</td>
                                <td>{data?.owner?.phone}</td>
                                <td>
                                  {
                                    data.tenantSubcription
                                      ?.tenantSubscriptionEnum
                                  }
                                </td>
                                <td>{data?.tenantSubcription?.graceDays}</td>
                                <td>
                                  {data?.tenantSubcription?.gracePeriod
                                    ? new Date(
                                      data?.tenantSubcription?.gracePeriod +
                                      "Z",
                                    ).toLocaleString()
                                    : "-"}
                                </td>
                                <td>
                                  {data?.tenantSubcription?.startDate
                                    ? new Date(
                                      data.tenantSubcription.startDate,
                                    ).toLocaleString()
                                    : "-"}
                                </td>

                                <td>
                                  {data?.tenantSubcription?.expireDate
                                    ? new Date(
                                      data.tenantSubcription.expireDate,
                                    ).toLocaleString()
                                    : "-"}
                                </td>
                                <td>{data.status}</td>

                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* PAGINATION FOOTER */}
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          <span>
                            Page{" "}
                            <strong>
                              {currentStart + 1} of {totalPages}
                            </strong>
                          </span>
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className={`paginate_button previous ${page === 0 ? "disabled" : ""
                              }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page > 0) setPage(page - 1);
                            }}
                          >
                            Previous
                          </Link>

                          <Link
                            className={`paginate_button next ${page + 1 >= totalPages ? "disabled" : ""
                              }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page + 1 < totalPages) setPage(page + 1);
                            }}
                          >
                            Next
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>
      <DuesPaymentModal
        show={paymentModal}
        onClose={() => setPaymentModal(false)}
        userData={selectedUser}
        onPaymentSuccess={() => {
          setPaymentModal(false);
          fetchUserData({ page, size, search });
        }}
      />
    </>
  );
};

export default AcademicesReport;
